<div class="nested-accordion">
  <div
    *ngFor="let item of items; let indx = index"
    class="nested-accordion-loop mb-2"
  >
    <div
      class="accordion-item"
      *ngIf="
        item.level !== 'goal' &&
        item.level !== 'term' &&
        item.level !== 'risk' &&
        ((context?.componentName?.name === 'PreviewComponent' &&
          item.selected) ||
          !context?.componentName)
      "
    >
      <div
        class="accordion-header"
        (click)="toggleAccordion(item) && $event.stopPropagation()"
        [ngStyle]="{ backgroundColor: item.expanded ? getColor() : '' }"
      >
        <div
          class="title-hol"
          [ngStyle]="{
            flex: fromPage == 'toe' ? 'auto' : '',
            'align-items': fromPage == 'toe' ? 'baseline' : ''
          }"
        >
          <input
            *ngIf="item.id"
            type="checkbox"
            [checked]="item.selected"
            [disabled]="
              disabled ||
              !hasTerms(item) ||
              isObjective(item) ||
              isRiskDomain(item) ||
              is_vendor
            "
            (change)="item.selected = !item.selected; selectGoals($event, item)"
            (click)="$event.stopPropagation()"
          />
          <span class="log-number ml-1">{{ indx + 1 }}</span>
          <div class="row col-12" *ngIf="fromPage === 'toe' && !item.id">
            <mat-form-field appearance="outline" class="col-12">
              <mat-label>Sub Category Name</mat-label>
              <input
                type="text"
                matInput
                fullWidth
                [(ngModel)]="subCategoryName"
              />
            </mat-form-field>
            <div class="row">
              <div
                class="col-md-4 ml-auto d-flex align-items-center justify-content-end"
                style="margin-left: 400px"
              >
                <button
                  mat-stroked-button
                  color="primary"
                  class="mx-1 p-0"
                  (click)="closeSubCategory($event, item)"
                >
                  Cancel
                </button>
                <button
                  mat-flat-button
                  mat-button
                  class="bg-primary text-white mx-1"
                  color="primary"
                  (click)="updateSubCategory($event, item)"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>

          <div class="title" *ngIf="fromPage === 'toe' && item.id">
            {{ item.name }}
          </div>
          <div class="title" *ngIf="fromPage !== 'toe'">{{ item.name }}</div>
          <div
            *ngIf="
              fromPage === 'toe' &&
              (item.level === 'category' || item.level === 'subcategory') &&
              !is_vendor
            "
          >
            <mat-icon
              aria-hidden="false"
              aria-label="material-icons-filled"
              (click)="add($event, item)"
              *ngIf="item.id"
              class="cursor-pointer fs-5 px-3"
              [ngClass]="{ 'disabled-icon': iframeEmbedded }"
            >
              add
            </mat-icon>
          </div>
        </div>

        <div class="formParentArrow p-2 d-flex align-items-center">
          <mat-icon
            class="material-icons-outlined arrow-icon"
            *ngIf="!item.expanded"
          >
            keyboard_arrow_down
          </mat-icon>
          <mat-icon
            class="material-icons-outlined arrow-icon"
            *ngIf="item.expanded"
          >
            keyboard_arrow_up
          </mat-icon>
        </div>
      </div>
      <div class="accordion-content" [hidden]="!item.expanded">
        <app-loading *ngIf="loading"></app-loading>
        <app-selection-tree-listing
          [tree]="tree"
          *ngIf="item.children"
          [disabled]="disabled"
          [(items)]="item.children"
          [context]="context"
          [fromPage]="fromPage"
          [(frequencyList)]="frequencyList"
          [(userList)]="userList"
          [captureContext]="captureContext"
          [functionList]="functionList"
          [evidenceList]="evidenceList"
        ></app-selection-tree-listing>
      </div>
    </div>
    <div
      *ngIf="
        (item.level === 'goal' ||
          item.level === 'term' ||
          item.level === 'risk') &&
        ((context?.componentName?.name === 'PreviewComponent' &&
          item.selected) ||
          !context?.componentName)
      "
      class="hov"
    >
      <div
        [ngStyle]="{ backgroundColor: getColor() }"
        class="last-level"
        [ngStyle]="{ display: fromPage === 'toe' ? 'block' : 'inherit' }"
      >
        <div style="display: flex; align-items: flex-start">
          <input
            *ngIf="item.id && !isGoal(item)"
            #checkboxes
            style="margin-right: 5px; margin-top: 3px"
            type="checkbox"
            [checked]="item.selected"
            [disabled]="disabled || is_vendor"
            (change)="item.selected = !item.selected; selectGoals($event, item)"
          />
          <span class="log-number ml-1 mr-0" style="font-size: 13px">{{
            indx + 1
          }}</span>
          <div class="leveltext" *ngIf="item.level === 'risk'&& item?.risk_id != null">
              {{ item?.risk_id }} - {{ item?.name }}
          </div>
          <div class="leveltext" *ngIf="item.level === 'risk'&& item?.risk_id === null">
              {{ item?.name }}
          </div>
          <div class="leveltext" *ngIf="item.level !== 'risk' && fromPage !== 'toe'">
            {{ item?.goal_name || item?.name }}
          </div>
          <div class="leveltext" *ngIf="item.level !== 'risk' && fromPage === 'toe' && item.id">
            {{ item?.goal_name || item?.name }}
          </div>
          <div *ngIf="fromPage === 'toe' && !item.id">
            <mat-form-field appearance="outline" class="w-100 pr-2 pl-2">
              <mat-label>Term Name</mat-label>
              <input type="text" matInput fullWidth [(ngModel)]="termName" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-50 pr-2 pl-2">
              <mat-label>Function</mat-label>
              <mat-select
                placeholder="Function"
                [(ngModel)]="termFunction"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option *ngFor="let fun of functionList" [value]="fun.id"
                  >{{ fun?.display_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-50 pr-2 pl-2">
              <mat-label>Fulfilled By</mat-label>
              <mat-select
                [(ngModel)]="termFulfilledBy"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option value="Enterprise">Enterprise</mat-option>
                <mat-option value="Vendor">Vendor</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-50 pr-2 pl-2">
              <mat-label>Evidence</mat-label>
              <mat-select
                placeholder="Evidence"
                [(ngModel)]="termEvidence"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option *ngFor="let evd of evidenceList" [value]="evd.id"
                  >{{ evd?.display_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-50 pr-2 pl-2">
              <mat-label>Domain</mat-label>
              <input
                type="text"
                matInput
                fullWidth
                status="basic"
                placeholder="Domain"
                [(ngModel)]="termDomain"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-50 pr-2 pl-2">
              <mat-label>Definition of done</mat-label>
              <input
                type="text"
                matInput
                fullWidth
                placeholder="Definition of done"
                [(ngModel)]="termDOD"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
            <div class="row mt-2">
              <div
                class="col-md-4 ml-auto d-flex align-items-center justify-content-end"
              >
                <button
                  mat-stroked-button
                  color="primary"
                  class="mx-1 p-0"
                  (click)="closeTerm($event, item)"
                >
                  Cancel
                </button>
                <button
                  mat-flat-button
                  mat-button
                  class="bg-primary text-white mx-1"
                  color="primary"
                  (click)="updateTerm(item)"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
          <mat-icon
            *ngIf="item?.is_recomended"
            matTooltip="Recommended"
            matTooltipClass="example-tooltip"
            style="margin-left: auto; color: rgb(255, 184, 5)"
          >
            star
          </mat-icon>
        </div>
        <div *ngIf="fromPage === 'toe'" class="comment-input-sec">
          <div style="font-size: 14px; margin-top: 5px;">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <div class="d-flex align-items-start mb-2" *ngIf="item?.function">
                  <b class="flex-shrink-0" style="width: 100px;">Function:</b>
                  <span class="text-break">{{ item?.function?.display_name }}</span>
                </div>
                
                <div class="d-flex align-items-start mb-2" *ngIf="item?.fulfilment_by">
                  <b class="flex-shrink-0" style="width: 100px;">Fulfilled By:</b>
                  <span class="text-break">{{ item?.fulfilment_by }}</span>
                </div>

                <div class="d-flex align-items-start mb-2" *ngIf="item?.evidence">
                  <b class="flex-shrink-0" style="width: 100px;">Evidence:</b>
                  <span>{{ item?.evidence?.display_name }}</span>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="d-flex align-items-start mb-2" *ngIf="item?.domain">
                  <b class="flex-shrink-0" style="width: 130px;">Domain:</b>
                  <span class="text-break">{{ item?.domain }}</span>
                </div>

                <div class="d-flex align-items-start mb-2" *ngIf="item?.defination_of_done">
                  <b class="flex-shrink-0" style="width: 130px;">Definition of Done:</b>
                  <span class="text-break">{{ item?.defination_of_done }}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
        <br />
        <!-- <label>Context</label> -->
        <div
          *ngIf="
            fromPage == 'toe' && item.id && item.selected && captureContext
          "
        >
          <div class="row terms-fields">
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" class="col-12">
                  <mat-label>Context</mat-label>
                  <input
                    matInput
                    [value]="item?.context ? item.context : ''"
                    (click)="$event.stopPropagation()"
                    (keyup)="emitCommentValue($event, item, 'comments')"
                    placeholder="Context"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <mat-form-field appearance="outline" class="col-12">
                  <mat-label>Frequency</mat-label>
                  <mat-select
                    (click)="$event.stopPropagation()"
                    [(ngModel)]="item.frequency"
                    (selectionChange)="
                      emitCommentValue($event, item, 'frequency')
                    "
                  >
                    <mat-option
                      *ngFor="let fun of frequencyList"
                      [value]="fun.id"
                      >{{ fun?.display_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance="outline" class="col-12">
                  <mat-label>Due Date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    readonly
                    class="fw-500"
                    [value]="item.due_date"
                    (dateChange)="emitCommentValue($event, item, 'due_date')"
                    (click)="$event.stopPropagation(); picker.open()"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker> </mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
          <!-- Project metrics and evidence -->
          <div class="d-flex justify-content-end">
            <button
              mat-button
              mat-flat-button
              class="bg-primary text-whtie mr-4"
              (click)="onClickMetrics(item, MetricsPopUp)"
              [disabled]="iframeEmbedded"
              color="primary"
            >
              Metrics
            </button>
            <button
              mat-button
              mat-flat-button
              class="bg-primary text-whtie"
              (click)="onClickEvidence(item, EvidencePopUp)"
              color="primary"
              [disabled]="iframeEmbedded"
            >
              Evidence
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Metrics Update -->
<ng-template #MetricsPopUp>
  <div class="dialog-wrapper m-0" style="max-width: 100%; overflow: hidden">
    <app-modal-header-common [title]="'Metrics Update'" [dialogRef]="dialogRef">
    </app-modal-header-common>
    <div class="dialog-content" style="border: none">
      <div class="modal-body p-0">
        <div class="saw d-flex row">
          <div class="col">
            <div class="d-flex mb-2" style="align-items: center">
              <span class="sjec obj">Category: </span>
              <p class="mb-0">{{ termDetails?.category }}</p>
            </div>
            <div class="d-flex mb-2" style="align-items: center">
              <span class="sjec krq">Sub Category: </span>
              <p class="mb-0">{{ termDetails?.subcategory }}</p>
            </div>
            <div class="d-flex mb-2" style="align-items: center">
              <span class="sjec gol">Term: </span>
              <p class="mb-0">{{ termDetails?.name }}</p>
            </div>
            <div
              *ngIf="termDetails?.instancemetrics.length"
              class="d-flex mb-2"
              style="align-items: center"
            >
              <span class="sjec gol" style="background: #0f7b68"
                >Metrics:
              </span>
              <mat-form-field style="font-size: 12px">
                <mat-label></mat-label>
                <mat-select
                  [(ngModel)]="selectedMetric"
                  (selectionChange)="selectedMatricEvent($event)"
                >
                  <mat-option>Select Metric</mat-option>
                  <mat-option
                    *ngFor="let mos of termDetails?.instancemetrics"
                    value="{{ mos.id }}"
                    >{{ mos?.instancemetrics__display_name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="d-flex mb-2"
              style="align-items: center"
              *ngIf="selectedMetricObj"
            >
              <span class="sjec gol" style="background: #0f7b68">Year: </span>
              <mat-form-field style="font-size: 12px">
                <mat-label></mat-label>
                <mat-select
                  [(ngModel)]="selectedPeriod"
                  (selectionChange)="selectedMatricYear()"
                >
                  <mat-option>Select Period</mat-option>
                  <mat-option *ngFor="let year of years" [value]="year">
                    {{ year }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              *ngIf="selectedMetricObj && selectedPeriod"
              class="d-flex justify-content-between p-4 pt-0"
              style="height: auto"
            >
              <span>Target Value : {{ selectedMetricObj?.target_value }} </span>
            </div>
          </div>
          <div
            *ngIf="selectedMetricObj && selectedPeriod"
            class="col table-container table-responsive"
            style="height: auto"
          >
            <table class="text-center">
              <thead style="position: sticky; top: 0; z-index: 1">
                <tr>
                  <th class="fixed-header text-center" scope="col">Month</th>
                  <th class="fixed-header text-center" scope="col">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let m of monthList; let i = index">
                  <td class="highlighted text-center">{{ m.month }}</td>
                  <td style="padding: 5px">
                    <div class="d-flex justify-content-center" *ngIf="m.edit">
                      <input
                        type="text"
                        [(ngModel)]="m.value"
                        class="form-control"
                        placeholder="Enter Number"
                        style="font-size: 12px; width: 100px"
                      />
                    </div>
                    <div class="d-flex justify-content-between" *ngIf="!m.edit">
                      <div></div>
                      <span>{{ m?.value || 0 }}</span>
                      <i class="fa fa-edit" (click)="editColum(i)"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      style="display: flex; justify-content: end"
      class="modal-footer m-2 gap-2"
    >
      <button mat-button color="secondary" (click)="closeDialog()">
        Close
      </button>
      <button
        *ngIf="selectedMetricObj && selectedPeriod"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="matricTarVal()"
      >
        Submit
      </button>
    </div>
  </div>
</ng-template>
<!-- Metrics Update End -->
<!-- Evidence Update -->
<ng-template #EvidencePopUp>
  <div class="dialog-wrapper m-0" style="max-width: 100%">
    <app-modal-header-common
      [title]="'Evidence Update'"
      [dialogRef]="dialogRef"
    >
    </app-modal-header-common>
    <div class="dialog-content" style="border: none">
      <div class="modal-body p-0">
        <div class="saw">
          <div class="d-flex mb-2" style="align-items: center">
            <span class="sjec obj">Evidence: </span>
            <p class="mb-0">{{ termDetails?.evidence?.display_name }}</p>
          </div>
          <div class="d-flex mb-2" style="align-items: center">
            <span class="sjec gol" style="background: #0f7b68"
              >Compliance:
            </span>
            <mat-form-field style="font-size: 12px">
              <mat-label></mat-label>
              <mat-select [(ngModel)]="selectedCompliance">
                <mat-option>Select Compliance</mat-option>
                <mat-option value="Met">Met</mat-option>
                <mat-option value="NotMet">Not Met</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="d-flex">
            <mat-form-field
              *ngIf="
                selectedCompliance == 'Met' || selectedCompliance == 'NotMet'
              "
              class="w-25"
            >
              <mat-label>Date</mat-label>
              <input
                matInput
                [(ngModel)]="selectedDate"
                [matDatepicker]="picker"
                readonly
                class="fw-500"
                (click)="picker.open()"
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker> </mat-datepicker>
            </mat-form-field>
            <mat-form-field
              *ngIf="selectedCompliance == 'Met'"
              class="w-25 ml-4"
            >
              <mat-label>Owner</mat-label>
              <mat-select [(ngModel)]="selectedOwner">
                <mat-option *ngFor="let user of userList" [value]="user.id"
                  >{{ user?.first_name }} {{ user?.last_name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <mat-form-field
              *ngIf="
                selectedCompliance == 'Met' || selectedCompliance == 'NotMet'
              "
              class="ml-4"
            >
              <mat-label>Comment</mat-label>
              <input
                matInput
                [(ngModel)]="selectedComment"
                placeholder="Comment"
              />
            </mat-form-field>
          </div>
          <div
            *ngIf="selectedCompliance == 'Met'"
            class="d-flex justify-content-between"
          >
            <div>
              <mat-label style="font-size: 14px">Upload Document *</mat-label
              ><br />
              <button mat-icon-button color="success">
                <input
                  hidden
                  #fileInput
                  type="file"
                  id="file"
                  (change)="onFileSelected($event)"
                />
                <mat-icon (click)="fileInput.click()">cloud_upload</mat-icon>
              </button>
              <span>{{ documentFilename }}</span>
            </div>
          </div>
          <div
            *ngIf="
              selectedCompliance === 'Met' || selectedCompliance === 'NotMet'
            "
            class="float-right"
          >
            <button
              type="submit"
              mat-raised-button
              color="primary"
              class="templ-btn ml-2 mb-2"
              (click)="saveEvidence()"
              [disabled]="iframeEmbedded"
            >
              Submit
            </button>
          </div>
          <div
            class="table-container table-responsive pt-4"
            style="height: auto"
          >
            <h6>Summary</h6>
            <app-loading *ngIf="loadingEvidence"></app-loading>
            <table [hidden]="loadingEvidence">
              <thead style="position: sticky; top: 0; z-index: 1">
                <tr>
                  <th scope="col">Date</th>
                  <th scope="col">Owner</th>
                  <th scope="col">Comment</th>
                  <th scope="col">Evidence</th>
                  <th scope="col">Compliance</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let det of termEvidenceList">
                  <td style="white-space: nowrap">
                    {{ det?.date | appFormat : "date" }}
                  </td>
                  <td
                    matTooltip="{{ det?.owner?.first_name }} {{
                      det?.owner?.last_name
                    }}"
                  >
                    <img
                      src="./assets/Icons/user.svg"
                      *ngIf="det?.owner?.first_name && det?.owner?.last_name"
                      width="15px"
                      height="15px"
                      class="mr-1"
                    />
                    <span *ngIf="det?.owner">
                      {{ det?.owner?.first_name }} {{ det?.owner?.last_name }}
                    </span>
                    <span *ngIf="!det.owner"> - </span>
                  </td>
                  <td [matTooltip]="det?.comment">{{ det?.comment }}</td>
                  <td>
                    <a *ngIf="det?.file_name" href="{{ det.url }}">{{
                      det?.file_name
                    }}</a>
                    <span *ngIf="!det?.file_name"> - </span>
                  </td>
                  <td>{{ getCompliance(det?.compliance_met) }}</td>
                </tr>
                <tr *ngIf="termEvidenceList?.length == 0">
                  <td colspan="5" class="text-center">
                    No historical data available
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer border-0 text-right">
      <button (click)="closeDialog()" mat-button color="secondary">
        Close
      </button>
    </div>
  </div>
</ng-template>
<!--Evidence Update end-->
